var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalTabs1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 31,
    viewBox: "0 0 67 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10694",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.328125 7.69995H76.3281V8.69995H0.328125V7.69995Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10695",
    d: "M0.828125 13.2H75.8281V30.2H0.828125V13.2Z",
    stroke: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10696",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.328125 7.69995H22.3281V8.69995H0.328125V7.69995Z",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23983",
    x: 3.32812,
    width: 16,
    height: 6,
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23984",
    x: 30.3281,
    width: 16,
    height: 6,
    fill: "#C4C4C4",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23985",
    x: 57.3281,
    width: 16,
    height: 6,
    fill: "#C4C4C4",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTabs1A);
export default __webpack_public_path__ + "static/media/HorizontalTabs1A.d3f283ff05b62dbbd8008ea1eba28436.svg";
export { ForwardRef as ReactComponent };